export default {
	setCategories(state, categories) {
		state.categories = categories
	},
}
